import { Dispatch } from 'redux';

import * as QuickmodeDataSearchActions from '../actions/quickModeOrgUserRegisterIniUser';
import * as QuickmodeDataSearchLogFileActions from '../actions/quickModeOrgUserRegisterLogFile';
import AbstractScenario from './AbstractScenario';

export default class QuickModeOrgUserRegisterUserListFactory {
	/**
	 * QuickModeDataUpdateLogin画面初期化データ取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchQuickModeOrgUserList(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(orgID: string) {
				// 初期化
				this.dispatch(
					QuickmodeDataSearchActions.setSearchOrgUsersList({
						searchOrgUserItemArry: [],
					})
				);

				// データ取得
				const doScenario = QuickModeOrgUserRegisterUserListFactory.createDoFetchQuickModeOrgUserList(
					this.dispatch,
					this.token
				);
				return doScenario.run(orgID).then(data => {
					this.dispatch(
						QuickmodeDataSearchActions.setSearchOrgUsersList(data)
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * QuickModeDataUpdateLogin画面情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDoFetchQuickModeOrgUserList(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(orgID: string) {
				const param = {
					orgID,
				};
				return this.read(
					'per_quickmode_QuickModeOrgUserListBlockModel',
					param
				).then(data => ({
					searchOrgUserItemArry: data as QuickmodeDataSearchActions.ISearchOrgUserItem[],
				}));
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * ログファイルをダウンロード
	 * @param dispatch
	 * @param token
	 */
	public static createFetchLogDownload(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				const params = {
					accessType: 10,
				};
				return this.read(
					'per_quickmode_QuickModeLogBlockModel',
					params
				).then(data => {
					this.dispatch(
						QuickmodeDataSearchLogFileActions.setLogFile({
							data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/QuickModeOrgUserRegisterUserListFactory.ts